const branchesViewTemplate = `
<div>
   <div  class="container">
        <div class="row">
	                <select name="groupSelection"
	                        id="groupSelection"
	                        ng-model="branchesCtrl.selectedGroup"
	                        class="form-control"
	                        ng-change="branchesCtrl.selectGroup()"
	                        >
	                    <option value="">Select Group</option>
	                    <option value="{{group}}" ng-repeat="group in branchesCtrl.groups"> {{group}}</option>
	                </select>
        </div>
        <div class="row">
           <p>
              <div ng-if="!branchesCtrl.isTokenInCookie()" ng-click="branchesCtrl.showStats = !branchesCtrl.showStats">
                  <p>Provide authentication token &amp; branch name.</p>
              </div>
              <div ng-if="branchesCtrl.isTokenInCookie()">
                  <span ng-click="branchesCtrl.showStats = !branchesCtrl.showStats">
                      Provide branch name.
                  </span>
                  <span>
                    (<i><a ng-click="branchesCtrl.clearToken()">clear token</a></i>)
                  </span>
              </div>
           </p>
        </div>
       <div class="row">
         <form role="form" autocomplete="off">
                <input ng-if="!branchesCtrl.isTokenInCookie()"
                       type="text"
                       id="token"
                       name="token"
                       SIZE="30"
                       placeholder="Token"
                       data-ng-required="true"
                       data-ng-model="branchesCtrl.token"
                       />
                 <input type="text"
                       id="branch"
                       name="branch"
                       SIZE="30"
                       placeholder="BranchName"
                       data-ng-required="true"
                       data-ng-model="branchesCtrl.branch"
                       />
                 <button
                  type="submit"
                  class="btn-primary"
                  ng-class="{ 'disabled-loading' : branchesCtrl.loading() }"
                  ng-click="branchesCtrl.doSearch()"
                  ng-disabled="branchesCtrl.loading() || !branchesCtrl.token || !branchesCtrl.branch"
                  ><span>{{ branchesCtrl.loading() ? 'Processing...' : 'Search'}}</span>
                </button>
          </form>
       </div>

       <div class="row" ng-if="branchesCtrl.showStats">
                Repos:[{{branchesCtrl.getRepoCount()}}]
                Found:[{{branchesCtrl.rslts.length}}]
                NotFound:[{{branchesCtrl.notFound.length}}]
                Errors=[{{branchesCtrl.errors.length}}]
                searchInProgress=[{{branchesCtrl.searchInProgress}}]
        </div>


       <!-- errors -->
       <div ng-if="branchesCtrl.accessError" class="margin-top-100">
            <div class="alert alert-danger">
                <p>Access Error. Please enable 'Load unsafe scripts' in location bar. </p>
            </div>
        </div>
       <div ng-if="branchesCtrl.errors && branchesCtrl.errors.length > 0" class="margin-top-100">
            <div ng-repeat="error in branchesCtrl.errors track by $index" class="alert alert-danger">
                <p>{{error}}</p>
            </div>
        </div>

       <div id="statementsDocs-spinner" class="loaderBackground just-element" ng-if="!branchesCtrl.initialized || branchesCtrl.loading()">
            <div class="loader"></div>
        </div>

        <div class="row margin-top-100" ng-if="branchesCtrl.loading()">
             <p>Please be patient...searching {{branchesCtrl.getResultsCount()}}/<strong>{{branchesCtrl.getRepoCount()}}</strong> repositories....</p>
        </div>

       <div class="row" ng-if="branchesCtrl.rslts.length > 0 && branchesCtrl.branch">
           <h2></h2>
           <table class="table table-striped">
                <thead>
                    <tr>
                        <td><strong>Group</strong></td>
                        <td><strong>Repo</strong></td>
                        <td><strong>MergeRequests</strong></td>
                    </tr>
                </thead>
                <tbody>
                    <tr ng-repeat="item in branchesCtrl.rslts | orderBy:'group'">

                        <td><a ng-href="{{branchesCtrl.gitLabCfg.baseUrl}}/{{item.group}}" target="_blank">{{item.group}}</a></td>
                        <td><a ng-href="{{branchesCtrl.gitLabCfg.baseUrl}}/{{item.group}}/{{item.repo.name}}/tree/{{branchesCtrl.branch}}" target="_blank">{{item.repo.name}}</a></td>
                        <td>
                            <div ng-if="item.toProd && item.toProd.length > 0">
                               <font color="#00a825">Production MR exists</font> 
                               (
                               <span ng-repeat="mr in item.toProd">
                                    <a ng-href="{{branchesCtrl.gitLabCfg.baseUrl}}/{{item.group}}/{{item.repo.name}}/merge_requests/{{mr.iid}}" 
                                          title="Author: {{mr.author.name}}"
                                          target="_blank">{{mr.iid}}</a>
                               </span>
                               )
                            </div>
                            <div ng-if="item.inbound && item.inbound.length > 0">
                               <font color="#fe0006">{{item.inbound.length}} outstanding merge requests!</font>
                               (
                               <span ng-repeat="mr in item.inbound">
                                    <a ng-href="{{branchesCtrl.gitLabCfg.baseUrl}}/{{item.group}}/{{item.repo.name}}/merge_requests/{{mr.iid}}" 
                                          title="Author: {{mr.author.name}}"
                                          target="_blank">{{mr.iid}}</a>
                               </span>
                               )
                            </div>

                        </td>

                    </tr>
                </tbody>
           </table>
       </div>
   </div>
</div>
`;
export default branchesViewTemplate;
